export default class PotmResultsMetaModel {
  public total: number;
}
